import React from 'react';
import {Alert} from 'react-bootstrap';

const ToastMessage = ({type = 'warning', message, onDismiss}) => {
  if (!message) {
    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      top: 20,
      right: 20,
      zIndex: 9999
    }}>
      <div style={{marginBottom: '10px'}}>
        <Alert variant={type} onClose={onDismiss} dismissible={!!onDismiss}>
          {message}
        </Alert>
      </div>
    </div>
  );
}

export default ToastMessage;